/**
 * <tag-tabs> custom element
 * Handles AJAX-based tag filtering for collection pages.
 * Falls back to normal navigation if fetch fails or JS is unavailable.
 */
class TagTabs extends HTMLElement {
  connectedCallback() {
    this.gridSelector = this.dataset.gridSelector || '#ProductGridContainer';
    this.grid = document.querySelector(this.gridSelector);

    this.addEventListener('click', this.onClick.bind(this));
    window.addEventListener('popstate', this.onPopState.bind(this));
  }

  onClick(event) {
    const link = event.target.closest('[data-tag-tab]');
    if (!link) return;

    // Already active, do nothing
    if (link.classList.contains('is-active')) {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    this.fetchAndRender(link.getAttribute('href'), link);
  }

  onPopState() {
    // Handle browser back/forward buttons
    const url = window.location.pathname + window.location.search;
    const matchingLink = this.querySelector(`[data-tag-tab][href="${url}"]`)
      || this.querySelector('[data-tag-tab][data-is-all]');
    this.fetchAndRender(url, matchingLink, { updateHistory: false });
  }

  async fetchAndRender(url, activeLink, options) {
    options = options || {};
    const updateHistory = options.updateHistory !== false;

    this.setLoading(true);

    try {
      const response = await fetch(url, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) throw new Error('Request failed: ' + response.status);

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newGrid = doc.querySelector(this.gridSelector);

      if (newGrid && this.grid) {
        this.grid.innerHTML = newGrid.innerHTML;
      }

      // Update active tab styling
      this.querySelectorAll('[data-tag-tab]').forEach((tab) => {
        tab.classList.remove('is-active');
      });
      if (activeLink) {
        activeLink.classList.add('is-active');
      }

      if (updateHistory) {
        window.history.pushState({}, '', url);
      }

      // Scroll product grid into view smoothly (skip on initial popstate)
      // if (updateHistory && this.grid) {
      //   this.grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // }

      document.dispatchEvent(
        new CustomEvent('tag-tabs:updated', { detail: { url: url } })
      );
    } catch (error) {
      console.error('Tag tabs: AJAX fetch failed, falling back to full page load.', error);
      window.location.href = url;
    } finally {
      this.setLoading(false);
    }
  }

  setLoading(state) {
    this.classList.toggle('is-loading', state);
    if (this.grid) {
      this.grid.classList.toggle('is-loading', state);
    }
  }
}

customElements.define('tag-tabs', TagTabs);
